<template>
    <div class="relative" v-bind:class="{'w-48 h-48': sizeFlag === 2,'w-40 h-40': sizeFlag === 1, 'w-20 h-20': sizeFlag === 0}">
        <div class="left-0 overflow-hidden absolute" v-bind:class="{'w-24 h-48': sizeFlag === 2,'w-20 h-40': sizeFlag === 1, 'w-10 h-20': sizeFlag === 0}">
            <div class="origin-[100%_50%] overflow-hidden absolute" v-bind:style="rightAngle" v-bind:class="{'w-24 h-48': sizeFlag === 2,'w-20 h-40': sizeFlag === 1, 'w-10 h-20': sizeFlag === 0}">
                <div class="left-0 absolute rounded-full border-orange-400" v-bind:class="{'w-48 h-48 border-[12px]': sizeFlag === 2,'w-40 h-40 border-[12px]': sizeFlag === 1, 'w-20 h-20 border-[6px]': sizeFlag === 0}">
                </div>
            </div>
        </div>
        <div class="right-0 overflow-hidden absolute" style="transform: scale(1,-1)" v-bind:class="{'w-24 h-48': sizeFlag === 2,'w-20 h-40': sizeFlag === 1, 'w-10 h-20': sizeFlag === 0}">
            <div class="origin-[0%_50%] overflow-hidden absolute" v-bind:style="leftAngle" v-bind:class="{'w-24 h-48': sizeFlag === 2,'w-20 h-40': sizeFlag === 1, 'w-10 h-20': sizeFlag === 0}">
                <div class="right-0 absolute rounded-full border-orange-400" v-bind:class="{'w-48 h-48 border-[12px]': sizeFlag === 2,'w-40 h-40 border-[12px]': sizeFlag === 1, 'w-20 h-20 border-[6px]': sizeFlag === 0}">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "done_cards_count",
        data(){
            return {
                progress:0,
            }
        },
            props:{
                doneStatusCards: Number,
                cards:Number,
                sizeFlag:Number,
            },
            computed:{
                rightAngle: function (){
                    let angle = Math.max(180-this.progress, 0);
                    return {
                        "transform": "rotate(" + angle + "deg)",
                    }
                },
                leftAngle: function (){
                    let angle = Math.max(this.progress, 180);
                    return {
                        "transform": "rotate(" + angle + "deg)",
                    }
                },
            },
        mounted() {
            this.progress = (this.doneStatusCards/this.cards)*360;
        }
    }
</script>
